import { createStore } from 'idb-keyval';

const customStore = createStore('MRAT_DB', process.env.REACT_APP_OFFLINE_DB);

export default customStore;
